(function () {
  var LOG = "[Rewards]";

  function qs(id) { return document.getElementById(id); }
  function showEl(el, v) { if (el) el.hidden = !v; }
  function isAuthenticated() { return !!window.supabaseSession?.session?.access_token; }

  function openAuthModal() {
    var m = document.getElementById("Account-Modal");
    if (m && typeof m.show === "function") m.show();
  }

  function pickWalletBalance(w) {
    if (!w || typeof w !== "object") return null;
    var n = w.points ?? w.balance ?? w.points_balance ?? w.available_balance;
    return typeof n === "number" ? n : null;
  }

  function formatPts(Smile, n) {
    if (n == null) return "—";
    if (typeof Smile?.formatPoints === "function") { try { return Smile.formatPoints(n); } catch (_) { } }
    return n.toLocaleString();
  }

  function formatBalNum(Smile, n) {
    if (n == null) return "—";
    return formatPts(Smile, n).replace(/\s*[Pp]oints\s*$/, "").trim() || formatPts(Smile, n);
  }

  /* ── Pick helpers (adapted to real Smile SDK shapes) ── */

  function pickProductTitle(pp) {
    // Smile SDK: name is often null for variable products; real name is in pp.reward.name
    return pp?.name || pp?.reward?.name || pp?.title || ("Reward #" + (pp?.id ?? ""));
  }

  function pickProductSubtitle(pp) {
    return pp?.reward?.description || pp?.subtitle || "";
  }

  function pickRuleTitle(r) { return r?.name || r?.title || r?.actionText || "Earn points"; }

  function buildEarnMeta(rule) {
    // Real Smile SDK shapes:
    //   { type: "fixed", fixed: { value: 1000 } }                        → "1,000 Points"
    //   { type: "variable", variable: { value: 1, perAmount: 1 } }       → "1 Point for every $1 spent"
    var rv = rule?.rewardValue ?? rule?.reward_value ?? null;
    if (rv) {
      if (rv.type === "fixed") {
        var pts = rv.fixed?.value ?? rv.fixed?.points ?? null;
        if (pts != null) return pts.toLocaleString() + " Points";
      }
      if (rv.type === "variable") {
        var v = rv.variable;
        if (v) {
          var pointsPer = v.value ?? v.points ?? v.pointsPerUnit ?? 1;
          var perDollar = v.perAmount ?? v.per_amount ?? 1;
          if (pointsPer === 1 && perDollar === 1) return "1 Point for every $1 spent";
          if (perDollar === 1) return pointsPer + " Points for every $1 spent";
          return pointsPer + " Points for every $" + perDollar + " spent";
        }
      }
    }

    // Fallback: legacy flat fields
    var pts2 = rule?.points_value ?? rule?.pointsValue ?? rule?.value ?? rule?.points ?? null;
    if (pts2 != null) return pts2.toLocaleString() + " Points";

    var desc = rule?.description || rule?.subtitle || "";
    if (desc) return desc;

    return "Earn points";
  }
  function pickPointsCost(pp) { return pp?.points_price ?? pp?.pointsPrice ?? pp?.points_cost ?? pp?.pointsCost ?? null; }

  function isVariableExchange(pp) {
    return String(pp?.exchange_type ?? pp?.exchangeType ?? "").toLowerCase() === "variable";
  }

  /* ── Variable exchange helpers (matched to real Smile SDK) ── */

  function getVarStep(pp) {
    // variablePointsStep = 300 (how many points per slider step)
    return pp?.variablePointsStep ?? pp?.variable_points_step ?? pp?.points_price ?? pp?.pointsPrice ?? 300;
  }

  function getVarStepValue(pp) {
    // variablePointsStepRewardValue = 1 (dollars per step, NOT cents)
    return pp?.variablePointsStepRewardValue ?? pp?.variable_points_step_reward_value ?? null;
  }

  function getVarMin(pp) {
    var explicit = pp?.variablePointsMin ?? pp?.variable_points_min ?? pp?.min_points_price ?? pp?.minPointsPrice ?? null;
    if (explicit != null && explicit > 0) return explicit;
    // Default: one step
    return getVarStep(pp);
  }

  function getVarMax(pp, balance) {
    var explicit = pp?.variablePointsMax ?? pp?.variable_points_max ?? pp?.max_points_price ?? pp?.maxPointsPrice ?? null;
    var step = getVarStep(pp);
    var effectiveMax = explicit != null && explicit > 0 ? explicit : null;

    // Cap to balance, snapped down to step
    if (effectiveMax != null && balance != null) {
      return Math.floor(Math.min(effectiveMax, balance) / step) * step;
    }
    if (effectiveMax != null) return effectiveMax;
    if (balance != null) return Math.floor(balance / step) * step;
    return step;
  }

  function calcDiscount(points, pp) {
    var step = getVarStep(pp);
    var stepVal = getVarStepValue(pp);
    if (!step || stepVal == null) return null;
    // stepVal is in dollars; compute total
    return (points / step) * stepVal;
  }

  function formatDollars(d) {
    if (d == null) return "";
    if (d === Math.floor(d)) return "$" + Math.floor(d);
    return "$" + d.toFixed(2);
  }

  /* Icons */
  var ICON_COPY = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>';
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_CHECK_CIRCLE = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';

  /* Clipboard */
  function copyToClipboard(text, btn) {
    if (!text) return;
    function ok() {
      var orig = btn.innerHTML;
      btn.innerHTML = ICON_CHECK + " Copied";
      btn.classList.add("rewards-page__copy--success");
      setTimeout(function () { btn.innerHTML = orig; btn.classList.remove("rewards-page__copy--success"); }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok).catch(function () { fbCopy(text); ok(); });
    } else { fbCopy(text); ok(); }
  }
  function fbCopy(t) {
    var a = document.createElement("textarea"); a.value = t; a.style.cssText = "position:fixed;opacity:0";
    document.body.appendChild(a); a.select(); document.execCommand("copy"); document.body.removeChild(a);
  }

  function buildCodeRow(code) {
    var row = document.createElement("div"); row.className = "rewards-page__code-row";
    var c = document.createElement("span"); c.className = "rewards-page__code"; c.textContent = code; row.appendChild(c);
    var b = document.createElement("button"); b.type = "button"; b.className = "rewards-page__copy"; b.innerHTML = ICON_COPY + " Copy";
    b.addEventListener("click", function () { copyToClipboard(code, b); }); row.appendChild(b);
    return row;
  }

  /* Error parsing */
  function parseRedeemError(e) {
    var msg = e?.message || e?.error?.message || String(e || "");
    var l = msg.toLowerCase();
    if (l.includes("insufficient") || l.includes("not enough") || l.includes("balance")) return "Not enough points to redeem this reward.";
    if (l.includes("already") || l.includes("redeemed")) return "This reward has already been redeemed.";
    if (l.includes("expired") || l.includes("unavailable")) return "This reward is no longer available.";
    if (l.includes("401") || l.includes("unauthorized") || l.includes("token")) return "Session expired. Please refresh the page.";
    return msg || "Could not redeem this reward. Please try again.";
  }

  /* Tab controller */
  var TAB_IDS = ["redeem", "earn", "referral", "history", "activity"];

  function TabController() {
    var tabs = {}, panels = {}, activeTab = null, available = {};
    TAB_IDS.forEach(function (id) { tabs[id] = qs("rewards-tab-btn-" + id); panels[id] = qs("rewards-tab-" + id); available[id] = false; });

    function activate(id) {
      if (!available[id]) return;
      activeTab = id;
      TAB_IDS.forEach(function (tid) {
        var on = tid === id;
        if (tabs[tid]) { tabs[tid].classList.toggle("rewards-tabs__tab--active", on); tabs[tid].setAttribute("aria-selected", on ? "true" : "false"); tabs[tid].setAttribute("tabindex", on ? "0" : "-1"); }
        if (panels[tid]) panels[tid].hidden = !on;
      });
    }

    TAB_IDS.forEach(function (id) { if (tabs[id]) tabs[id].addEventListener("click", function () { activate(id); }); });

    var bar = document.querySelector(".rewards-tabs__bar");
    if (bar) bar.addEventListener("keydown", function (e) {
      var vis = TAB_IDS.filter(function (id) { return available[id]; }), idx = vis.indexOf(activeTab), nxt = -1;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") nxt = (idx + 1) % vis.length;
      else if (e.key === "ArrowLeft" || e.key === "ArrowUp") nxt = (idx - 1 + vis.length) % vis.length;
      else if (e.key === "Home") nxt = 0;
      else if (e.key === "End") nxt = vis.length - 1;
      if (nxt >= 0) { e.preventDefault(); activate(vis[nxt]); if (tabs[vis[nxt]]) tabs[vis[nxt]].focus(); }
    });

    return {
      setAvailable: function (id, has) { available[id] = !!has; if (tabs[id]) tabs[id].hidden = !has; },
      activate: activate,
      show: function () {
        var el = qs("rewards-tabs"), vis = TAB_IDS.filter(function (id) { return available[id]; });
        if (!vis.length) { showEl(el, false); return; }
        showEl(el, true);
        if (!activeTab || !available[activeTab]) activate(vis[0]); else activate(activeTab);
      }
    };
  }

  /* ── Build variable exchange slider card ── */

  function buildVariableSlider(pp, Smile, walletBalance, onRedeem) {
    var li = document.createElement("li");
    li.className = "rewards-page__item rewards-page__item--reward rewards-page__item--variable";

    // Title (from reward.name e.g. "Order discount")
    var title = document.createElement("h3");
    title.className = "font-heading-bold margin0";
    title.textContent = pickProductTitle(pp);
    li.appendChild(title);

    // Exchange rate description: "300 Points = $1"
    var exchangeDesc = pp?.exchangeDescription || pp?.exchange_description || "";
    if (exchangeDesc) {
      var rateEl = document.createElement("p");
      rateEl.className = "rewards-page__variable-rate margin0";
      rateEl.textContent = exchangeDesc;
      li.appendChild(rateEl);
    }

    // Subtitle: "Applies to one-time purchases."
    var subtitle = pickProductSubtitle(pp);
    if (subtitle) {
      var subEl = document.createElement("p");
      subEl.className = "rewards-page__variable-subtitle margin0";
      subEl.textContent = subtitle;
      li.appendChild(subEl);
    }

    // Slider parameters
    var step = getVarStep(pp);
    var minPts = 0;
    var minRedeemPts = getVarMin(pp);
    var maxPts = getVarMax(pp, walletBalance);
    if (maxPts < minRedeemPts) maxPts = minRedeemPts;

    var canAffordSlider = walletBalance != null && walletBalance >= minRedeemPts;
    // Default thumb to maximum affordable value (not zero) so label shows full discount immediately
    var currentPts = canAffordSlider ? maxPts : minPts;

    // Slider UI
    var sliderWrap = document.createElement("div");
    sliderWrap.className = "rewards-slider";

    // Live label: "2400 Points for $8 off"
    var sliderLabel = document.createElement("div");
    sliderLabel.className = "rewards-slider__label";

    function updateLabel() {
      var discount = calcDiscount(currentPts, pp);
      if (discount != null && discount > 0) {
        sliderLabel.textContent = currentPts.toLocaleString() + " Points for " + formatDollars(discount) + " off";
      } else {
        sliderLabel.textContent = currentPts.toLocaleString() + " Points";
      }
    }
    updateLabel();
    sliderWrap.appendChild(sliderLabel);

    // Range input
    var slider = document.createElement("input");
    slider.type = "range";
    slider.className = "rewards-slider__input";
    slider.min = String(minPts);
    slider.max = String(canAffordSlider ? maxPts : minRedeemPts);
    slider.step = String(step);
    slider.value = String(currentPts);
    slider.disabled = !canAffordSlider;
    slider.setAttribute("aria-label", "Points to spend");
    if (!canAffordSlider) slider.style.opacity = "0.4";

    function updateSliderFill() {
      var pct = maxPts > minPts ? ((currentPts - minPts) / (maxPts - minPts)) * 100 : 100;
      slider.style.setProperty("--slider-pct", pct + "%");
    }
    updateSliderFill();

    slider.addEventListener("input", function () {
      currentPts = parseInt(slider.value, 10) || minPts;
      updateLabel();
      updateSliderFill();
    });
    sliderWrap.appendChild(slider);

    // Min / Max labels
    var rangeLabels = document.createElement("div");
    rangeLabels.className = "rewards-slider__range";
    var minDiscount = calcDiscount(minPts, pp);
    var maxDiscount = calcDiscount(maxPts, pp);
    var minText = minPts.toLocaleString() + " pts";
    var maxText = maxPts.toLocaleString() + " pts";
    if (minDiscount != null && minDiscount > 0) minText += " (" + formatDollars(minDiscount) + ")";
    if (maxDiscount != null && maxDiscount > 0) maxText += " (" + formatDollars(maxDiscount) + ")";
    rangeLabels.innerHTML = "<span>" + minText + "</span><span>" + maxText + "</span>";
    sliderWrap.appendChild(rangeLabels);

    li.appendChild(sliderWrap);

    // Feedback area
    var feedbackEl = document.createElement("div");
    feedbackEl.className = "rewards-page__card-feedback";
    feedbackEl.hidden = true;
    li.appendChild(feedbackEl);

    // Redeem button
    var canAfford = walletBalance != null && walletBalance >= minRedeemPts;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "button button--small rewards-page__cta";
    if (!canAfford) {
      btn.textContent = "Not enough points";
      btn.disabled = true;
      btn.className += " rewards-page__cta--insufficient";
    } else {
      btn.textContent = "Redeem";
      function updateBtnState() {
        var pts = parseInt(slider.value, 10) || 0;
        btn.disabled = pts < minRedeemPts;
      }
      updateBtnState();
      slider.addEventListener("input", updateBtnState);
      btn.addEventListener("click", function () {
        var pts = parseInt(slider.value, 10) || 0;
        if (pts < minRedeemPts) return;
        onRedeem(pp, btn, feedbackEl, pts);
      });
    }

    var actionRow = document.createElement("div");
    actionRow.className = "rewards-page__action-row";
    actionRow.appendChild(btn);
    li.appendChild(actionRow);

    return li;
  }

  /* ── Render read-only rewards (guest view — no redeem buttons) ── */

  function renderGuestList(container, products) {
    if (!container) return 0;
    container.innerHTML = "";
    if (!products?.length) return 0;
    var ul = document.createElement("ul");
    ul.className = "rewards-page__list";

    products.forEach(function (pp) {
      var li = document.createElement("li");
      li.className = "rewards-page__item rewards-page__item--reward";

      var header = document.createElement("div");
      header.className = "rewards-page__reward-header";
      var info = document.createElement("div");
      info.className = "rewards-page__reward-info";
      var title = document.createElement("h3");
      title.className = "font-heading-bold margin0";
      title.textContent = pickProductTitle(pp);
      info.appendChild(title);
      var desc = pickProductSubtitle(pp);
      if (desc) {
        var descP = document.createElement("p");
        descP.className = "rewards-page__meta margin0";
        descP.textContent = desc;
        info.appendChild(descP);
      }
      header.appendChild(info);

      var costN = pickPointsCost(pp);
      if (costN != null) {
        var costBadge = document.createElement("span");
        costBadge.className = "rewards-page__reward-cost";
        costBadge.textContent = costN.toLocaleString() + " pts";
        header.appendChild(costBadge);
      }
      li.appendChild(header);

      // Variable exchange description (no slider for guests)
      if (isVariableExchange(pp)) {
        var exchangeDesc = pp?.exchangeDescription || pp?.exchange_description || "";
        if (exchangeDesc) {
          var rateEl = document.createElement("p");
          rateEl.className = "rewards-page__variable-rate margin0";
          rateEl.textContent = exchangeDesc;
          li.appendChild(rateEl);
        }
      }

      ul.appendChild(li);
    });

    container.appendChild(ul);
    return products.length;
  }

  /* ── Render redeemable rewards ── */

  function renderList(container, products, Smile, walletBalance, onRedeemFixed, onRedeemVariable) {
    if (!container) return 0;
    container.innerHTML = "";
    if (!products?.length) return 0;
    var ul = document.createElement("ul");
    ul.className = "rewards-page__list";

    products.forEach(function (pp) {
      if (isVariableExchange(pp)) {
        ul.appendChild(buildVariableSlider(pp, Smile, walletBalance, onRedeemVariable));
        return;
      }

      var li = document.createElement("li");
      li.className = "rewards-page__item rewards-page__item--reward";

      var header = document.createElement("div");
      header.className = "rewards-page__reward-header";
      var info = document.createElement("div");
      info.className = "rewards-page__reward-info";
      var title = document.createElement("h3");
      title.className = "font-heading-bold margin0";
      title.textContent = pickProductTitle(pp);
      info.appendChild(title);
      var desc = pickProductSubtitle(pp);
      if (desc) {
        var descP = document.createElement("p");
        descP.className = "rewards-page__meta margin0";
        descP.textContent = desc;
        info.appendChild(descP);
      }
      header.appendChild(info);

      var costN = pickPointsCost(pp);
      if (costN != null) {
        var costBadge = document.createElement("span");
        costBadge.className = "rewards-page__reward-cost";
        costBadge.textContent = formatPts(Smile, costN) + " pts";
        header.appendChild(costBadge);
      }
      li.appendChild(header);

      var feedbackEl = document.createElement("div");
      feedbackEl.className = "rewards-page__card-feedback";
      feedbackEl.hidden = true;
      li.appendChild(feedbackEl);

      var btn = document.createElement("button"); btn.type = "button";
      var canAfford = walletBalance != null && costN != null && walletBalance >= costN;
      btn.className = "button button--small rewards-page__cta";
      if (!canAfford && walletBalance != null && costN != null) {
        btn.textContent = "Not enough points";
        btn.disabled = true;
        btn.className += " rewards-page__cta--insufficient";
      } else {
        btn.textContent = "Redeem";
        btn.dataset.pointsProductId = String(pp.id);
        btn.addEventListener("click", function () { onRedeemFixed(pp, btn, feedbackEl); });
      }
      var actionRow = document.createElement("div");
      actionRow.className = "rewards-page__action-row";
      actionRow.appendChild(btn);
      li.appendChild(actionRow);
      ul.appendChild(li);
    });

    container.appendChild(ul);
    return products.length;
  }

  /* Helpers */
  function pickRewardTitle(item) { return item?.reward?.name || item?.name || item?.title || ("Reward #" + (item?.id ?? "")); }
  function pickRewardCode(item) { return item?.discount_code || item?.discountCode || item?.code || item?.coupon_code || item?.fulfillment_value || null; }
  function pickRewardStatus(item) {
    var raw = item?.status || item?.state || (item?.used_at || item?.usedAt ? "used" : item?.expired_at || item?.expiredAt ? "expired" : "active");
    return String(raw || "active");
  }

  /* Earn icons */
  var EARN_ICONS = {
    signup: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>',
    order: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    default: '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>'
  };

  function pickEarnIcon(t) {
    var l = (t || "").toLowerCase();
    if (l.includes("sign") || l.includes("account") || l.includes("register")) return EARN_ICONS.signup;
    if (l.includes("order") || l.includes("purchase") || l.includes("buy") || l.includes("spend")) return EARN_ICONS.order;
    return EARN_ICONS.default;
  }

  function statusClass(s) {
    var l = (s || "").toLowerCase();
    if (l === "active" || l === "available") return "rewards-page__status--active";
    if (l === "used" || l === "redeemed") return "rewards-page__status--used";
    if (l === "expired") return "rewards-page__status--expired";
    return "";
  }

  /* Social action URL detection */
  function getSocialActionUrl(rule) {
    // Check for explicit URL from Smile SDK
    var url = rule?.action_url ?? rule?.actionUrl ?? rule?.url ?? null;
    if (url) return url;

    // Detect social type from rule name/title and return matching theme social link
    var name = (rule?.name || rule?.title || rule?.actionText || "").toLowerCase();
    if (name.includes("instagram")) return window.__smileSocialLinks?.instagram || null;
    if (name.includes("facebook") || name.includes("fb")) return window.__smileSocialLinks?.facebook || null;
    if (name.includes("twitter") || name.includes(" x ") || name.match(/\bx\b/)) return window.__smileSocialLinks?.twitter || null;
    if (name.includes("tiktok")) return window.__smileSocialLinks?.tiktok || null;
    if (name.includes("youtube")) return window.__smileSocialLinks?.youtube || null;
    return null;
  }

  function isSocialRule(rule) {
    var name = (rule?.name || rule?.title || rule?.actionText || "").toLowerCase();
    return name.includes("follow") || name.includes("share") || name.includes("instagram")
      || name.includes("facebook") || name.includes("twitter") || name.includes("tiktok")
      || name.includes("youtube") || name.includes("social");
  }

  function isBirthdayRule(rule) {
    var name = (rule?.name || rule?.title || rule?.actionText || "").toLowerCase();
    return name.includes("birthday") || name.includes("birth day") || name.includes("bday");
  }

  /* Render earn cards */
  function renderEarnCards(container, rules) {
    if (!container) return 0;
    container.innerHTML = "";
    if (!rules?.length) return 0;

    var ul = document.createElement("ul");
    ul.className = "rewards-page__list";

    rules.forEach(function (rule) {
      var li = document.createElement("li");
      li.className = "rewards-page__item rewards-page__item--earn";

      var completed = !!(rule.completed_at ?? rule.completedAt ?? rule.completed);

      // Use Smile's imageUrl if available, else fallback to SVG
      var iconWrap = document.createElement("div");
      iconWrap.className = "rewards-page__earn-icon";
      if (rule.imageUrl || rule.image_url) {
        var img = document.createElement("img");
        img.src = rule.imageUrl || rule.image_url;
        img.alt = "";
        img.width = 24;
        img.height = 24;
        img.className = "rewards-page__earn-img";
        iconWrap.appendChild(img);
      } else {
        iconWrap.innerHTML = pickEarnIcon(pickRuleTitle(rule));
      }
      li.appendChild(iconWrap);

      var content = document.createElement("div");
      content.className = "rewards-page__earn-content";

      var title = document.createElement("h3");
      title.className = "font-heading-bold margin0";
      title.textContent = pickRuleTitle(rule);
      content.appendChild(title);

      // Description: e.g. "1 Point for every $1 spent" or "1000 Points"
      var meta = buildEarnMeta(rule);
      var metaEl = document.createElement("p");
      metaEl.className = "rewards-page__earn-meta margin0";
      metaEl.textContent = meta;
      content.appendChild(metaEl);

      // Social action button
      if (isSocialRule(rule) && !completed) {
        var actionUrl = getSocialActionUrl(rule);
        if (actionUrl) {
          var btn = document.createElement("a");
          btn.href = actionUrl;
          btn.target = "_blank";
          btn.rel = "noopener noreferrer";
          btn.className = "rewards-page__earn-action";
          btn.textContent = pickRuleTitle(rule).includes("Follow") ? "Follow" : "Visit";
          content.appendChild(btn);
        }
      }

      // Birthday input — always render for birthday rules so customer can view/update their saved date
      if (isBirthdayRule(rule)) {
        var bdayWrap = document.createElement("div");
        bdayWrap.className = "rewards-page__birthday-input-wrap";

        var monthSelect = document.createElement("select");
        monthSelect.className = "rewards-page__birthday-input";
        monthSelect.id = "rewards-birthday-month";
        monthSelect.setAttribute("aria-label", "Birth month");
        var monthPlaceholder = document.createElement("option");
        monthPlaceholder.value = ""; monthPlaceholder.textContent = "Month"; monthPlaceholder.disabled = true; monthPlaceholder.selected = true;
        monthSelect.appendChild(monthPlaceholder);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        monthNames.forEach(function (name, i) {
          var opt = document.createElement("option");
          opt.value = String(i + 1).padStart(2, "0");
          opt.textContent = name;
          monthSelect.appendChild(opt);
        });
        bdayWrap.appendChild(monthSelect);

        var daySelect = document.createElement("select");
        daySelect.className = "rewards-page__birthday-input";
        daySelect.id = "rewards-birthday-day";
        daySelect.setAttribute("aria-label", "Birth day");
        var dayPlaceholder = document.createElement("option");
        dayPlaceholder.value = ""; dayPlaceholder.textContent = "Day"; dayPlaceholder.disabled = true; dayPlaceholder.selected = true;
        daySelect.appendChild(dayPlaceholder);
        for (var d = 1; d <= 31; d++) {
          var dopt = document.createElement("option");
          dopt.value = String(d).padStart(2, "0");
          dopt.textContent = String(d);
          daySelect.appendChild(dopt);
        }
        bdayWrap.appendChild(daySelect);

        var bdayBtn = document.createElement("button");
        bdayBtn.type = "button";
        bdayBtn.className = "rewards-page__earn-action";
        bdayBtn.textContent = completed ? "Update" : "Save";
        bdayBtn.addEventListener("click", function () {
          var month = monthSelect.value;
          var day = daySelect.value;
          if (!month || !day) return;
          bdayBtn.disabled = true;
          bdayBtn.textContent = "Saving\u2026";
          window.dispatchEvent(new CustomEvent("rewards:save-birthday", { detail: { date: month + "-" + day } }));
        });
        bdayWrap.appendChild(bdayBtn);

        // Status note shown below the selects (pre-fill + eligibility feedback)
        var bdayNote = document.createElement("p");
        bdayNote.className = "rewards-page__meta margin0";
        bdayNote.style.fontSize = "1.2rem";
        bdayNote.style.marginTop = "0.4rem";
        bdayNote.hidden = true;
        content.appendChild(bdayWrap);
        content.appendChild(bdayNote);

        // Pre-fill saved birthday from our backend
        (function () {
          var backendBaseUrl = window.SUMMIT_CHECKOUT_CONFIG?.backendBaseUrl;
          var accessToken = window.supabaseSession?.session?.access_token;
          var shop = window.Shopify?.shop || location.hostname;
          if (!backendBaseUrl || !accessToken) return;

          fetch(backendBaseUrl + "/api/smile/birthday?shop=" + encodeURIComponent(shop), {
            method: "GET",
            headers: { 
              Authorization: "Bearer " + accessToken,
              "Content-Type": "application/json",
            },
            credentials: "include",
          })
            .then(function (r) { return r.json().catch(function () { return null; }); })
            .then(function (result) {
              if (!result?.success || !result?.birthday) return;
              var bday = result.birthday;
              // Pre-fill the selects
              monthSelect.value = String(bday.month).padStart(2, "0");
              daySelect.value = String(bday.day).padStart(2, "0");

              // Show eligibility / status note
              var monthName = ["January","February","March","April","May","June","July","August","September","October","November","December"][bday.month - 1];
              if (completed) {
                bdayNote.textContent = "Birthday reward already awarded this year (\uD83C\uDF82 " + monthName + " " + bday.day + "). You can update your birthday below.";
                bdayNote.style.color = "#4ade80";
                bdayNote.hidden = false;
              } else {
                bdayNote.textContent = "Birthday set to " + monthName + " " + bday.day + ". Points will be awarded on your birthday.";
                bdayNote.style.color = "#c3a46b";
                bdayNote.hidden = false;
              }
            })
            .catch(function () { /* non-fatal — selects stay empty */ });
        })();
      }

      li.appendChild(content);

      if (completed) {
        var check = document.createElement("span");
        check.className = "rewards-page__earn-done";
        check.innerHTML = ICON_CHECK_CIRCLE;
        check.title = "Completed";
        li.appendChild(check);
      }

      ul.appendChild(li);
    });

    container.appendChild(ul);
    return rules.length;
  }

  /* Render my-reward cards */
  function renderMyRewardCards(container, items) {
    if (!container) return 0;
    container.innerHTML = "";
    if (!items?.length) {
      var empty = document.createElement("p");
      empty.className = "rewards-page__meta";
      empty.style.cssText = "text-align:center;padding:2rem 1rem;";
      empty.textContent = "You don't have any active reward codes yet. Redeem your points in the \"Way to Redeem\" tab to get discount codes!";
      container.appendChild(empty);
      return 0;
    }

    var ul = document.createElement("ul");
    ul.className = "rewards-page__list";

    items.forEach(function (item) {
      var li = document.createElement("li");
      li.className = "rewards-page__item rewards-page__item--my-reward";

      var header = document.createElement("div");
      header.className = "rewards-page__my-reward-header";
      var titleEl = document.createElement("h3");
      titleEl.className = "font-heading-bold margin0";
      titleEl.textContent = item.title;
      header.appendChild(titleEl);

      if (item.status) {
        var statusEl = document.createElement("span");
        statusEl.className = "rewards-page__status " + statusClass(item.status);
        statusEl.textContent = item.status;
        header.appendChild(statusEl);
      }
      li.appendChild(header);

      if (item.code) {
        li.appendChild(buildCodeRow(item.code));
      } else if (item.meta) {
        var meta = document.createElement("p");
        meta.className = "rewards-page__meta margin0";
        meta.textContent = item.meta;
        li.appendChild(meta);
      }

      if (item.expiresAt) {
        var expiryEl = document.createElement("p");
        expiryEl.className = "rewards-page__expiry margin0";
        try {
          var expiryDate = new Date(item.expiresAt);
          var now = new Date();
          var daysLeft = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
          if (daysLeft <= 0) {
            expiryEl.textContent = "Expired";
            expiryEl.classList.add("rewards-page__expiry--expired");
          } else if (daysLeft <= 7) {
            expiryEl.textContent = "Expires in " + daysLeft + " day" + (daysLeft > 1 ? "s" : "");
            expiryEl.classList.add("rewards-page__expiry--soon");
          } else {
            expiryEl.textContent = "Expires " + expiryDate.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
          }
        } catch (_) {
          expiryEl.textContent = "Expires " + String(item.expiresAt);
        }
        li.appendChild(expiryEl);
      }

      ul.appendChild(li);
    });

    container.appendChild(ul);
    return items.length;
  }

  /* ── VIP progress bar ── */

  function renderVipProgress(container, vs, tiers, walletBalance) {
    if (!container) return;
    container.innerHTML = "";

    var currentTierName = vs?.vipTier?.name || vs?.tier?.name || vs?.vip_tier?.name || vs?.name || null;
    var earnedPoints = vs?.progressValue ?? vs?.progress_value
      ?? vs?.points_earned ?? vs?.pointsEarned ?? null;

    // Fallback: use wallet balance if no VIP-specific earned points found
    if (earnedPoints == null && walletBalance != null) earnedPoints = walletBalance;

    // Sort tiers by min points threshold
    var sortedTiers = (tiers || []).slice().sort(function (a, b) {
      var aMin = a?.milestone ?? a?.min_points ?? a?.minPoints ?? a?.points_requirement ?? 0;
      var bMin = b?.milestone ?? b?.min_points ?? b?.minPoints ?? b?.points_requirement ?? 0;
      return aMin - bMin;
    });

    // Find current tier index
    var currentIdx = -1;
    sortedTiers.forEach(function (t, i) {
      var name = t?.name || "";
      if (name === currentTierName) currentIdx = i;
    });

    // Use SDK-provided next tier info (more reliable than computing from array)
    var nextTierFromSdk = vs?.nextVipTier ?? vs?.next_vip_tier ?? null;
    var deltaToNext = vs?.deltaToNextVipTier ?? vs?.delta_to_next_vip_tier ?? null;

    var nextTier = nextTierFromSdk || (currentIdx >= 0 && currentIdx < sortedTiers.length - 1 ? sortedTiers[currentIdx + 1] : null);
    var nextThreshold = null;
    if (nextTier) {
      // Find the matching tier in sortedTiers to get the milestone
      for (var ti = 0; ti < sortedTiers.length; ti++) {
        if (sortedTiers[ti].id === nextTier.id || sortedTiers[ti].name === nextTier.name) {
          nextThreshold = sortedTiers[ti]?.milestone ?? sortedTiers[ti]?.min_points ?? null;
          break;
        }
      }
    }

    var ul = document.createElement("ul"); ul.className = "rewards-page__list";
    var li = document.createElement("li"); li.className = "rewards-page__item rewards-page__item--vip-progress";

    // Current tier
    var tierLabel = document.createElement("h3");
    tierLabel.className = "font-heading-bold margin0";
    tierLabel.textContent = currentTierName ? "Current tier: " + currentTierName : "VIP status";
    li.appendChild(tierLabel);

    // Description
    var desc = vs?.description || vs?.progress_description || "";
    if (desc) {
      var descEl = document.createElement("p");
      descEl.className = "rewards-page__meta margin0";
      descEl.style.marginTop = "0.25rem";
      descEl.textContent = desc;
      li.appendChild(descEl);
    }

    // Progress bar (if we have earned points and a next tier threshold)
    if (earnedPoints != null && nextThreshold != null && nextThreshold > 0) {
      var pct = Math.min(Math.round((earnedPoints / nextThreshold) * 100), 100);
      var remaining = Math.max(nextThreshold - earnedPoints, 0);

      var progressWrap = document.createElement("div");
      progressWrap.className = "rewards-vip-progress";
      progressWrap.style.marginTop = "0.85rem";

      var displayRemaining = deltaToNext != null ? deltaToNext : remaining;
      var progressLabel = document.createElement("div");
      progressLabel.className = "rewards-vip-progress__label";
      progressLabel.textContent = displayRemaining > 0
        ? displayRemaining.toLocaleString() + " points to " + (nextTier.name || "next tier")
        : "Tier reached!";
      progressWrap.appendChild(progressLabel);

      var track = document.createElement("div");
      track.className = "rewards-vip-progress__track";
      var fill = document.createElement("div");
      fill.className = "rewards-vip-progress__fill";
      fill.style.width = pct + "%";
      track.appendChild(fill);
      progressWrap.appendChild(track);

      var rangeLabels = document.createElement("div");
      rangeLabels.className = "rewards-vip-progress__range";
      rangeLabels.innerHTML = "<span>" + earnedPoints.toLocaleString() + " pts</span><span>" + nextThreshold.toLocaleString() + " pts</span>";
      progressWrap.appendChild(rangeLabels);

      li.appendChild(progressWrap);
    }

    // Tier list (all tiers)
    if (sortedTiers.length > 1) {
      var tierList = document.createElement("div");
      tierList.className = "rewards-vip-tiers";
      tierList.style.marginTop = "0.85rem";

      sortedTiers.forEach(function (t, i) {
        var row = document.createElement("div");
        row.className = "rewards-vip-tiers__row";
        if (i === currentIdx) row.classList.add("rewards-vip-tiers__row--active");

        var name = document.createElement("span");
        name.className = "rewards-vip-tiers__name";
        name.textContent = t.name || "Tier " + (i + 1);
        row.appendChild(name);

        var threshold = t?.milestone ?? t?.min_points ?? t?.minPoints ?? t?.points_requirement ?? 0;
        if (threshold > 0) {
          var pts = document.createElement("span");
          pts.className = "rewards-vip-tiers__pts";
          pts.textContent = threshold.toLocaleString() + " pts";
          row.appendChild(pts);
        }

        tierList.appendChild(row);
      });

      li.appendChild(tierList);
    }

    ul.appendChild(li);
    container.appendChild(ul);
  }

  /* ── Referral share UI ── */

  function renderReferral(container, Smile) {
    if (!container) return false;
    container.innerHTML = "";

    // Show loading state while we fetch the referral link
    var loadingNote = document.createElement("p");
    loadingNote.className = "rewards-page__meta";
    loadingNote.style.textAlign = "center";
    loadingNote.style.padding = "1.5rem";
    loadingNote.textContent = "Loading referral link\u2026";
    container.appendChild(loadingNote);

    // Fetch customer data to get referralUrl (async)
    (async function () {
      var referralUrl = null;
      try {
        // Try Smile.customer.current() which returns the full customer object
        if (typeof Smile?.customer?.current === "function") {
          var customer = await Smile.customer.current();
          referralUrl = customer?.referralUrl ?? customer?.referral_url
            ?? customer?.referralLink ?? customer?.referral_link ?? null;
        }
        // Fallback: try direct property access
        if (!referralUrl) {
          referralUrl = Smile?.customer?.referralUrl ?? Smile?.customer?.referral_url
            ?? Smile?.customer?.referralLink ?? Smile?.customer?.referral_link ?? null;
        }
      } catch (_e) {
        console.warn(LOG + " referral link fetch failed", _e);
      }

      container.innerHTML = "";
      if (referralUrl) {
        buildReferralUI(container, referralUrl);
      } else {
        var note = document.createElement("p");
        note.className = "rewards-page__meta";
        note.style.textAlign = "center";
        note.style.padding = "1.5rem";
        note.textContent = "Share Summit Metals with friends and earn rewards when they make their first purchase! Your referral link will appear here once the referral program is active.";
        container.appendChild(note);
      }
    })();

    // Return true to always show the tab (async content will fill in)
    return true;
  }

  function buildReferralUI(container, referralUrl) {
    container.innerHTML = "";
    var ul = document.createElement("ul"); ul.className = "rewards-page__list";
    var li = document.createElement("li"); li.className = "rewards-page__item"; li.style.gridColumn = "1 / -1";

    var title = document.createElement("h3");
    title.className = "font-heading-bold margin0";
    title.textContent = "Refer a friend, earn rewards";
    li.appendChild(title);

    var desc = document.createElement("p");
    desc.className = "rewards-page__meta margin0";
    desc.style.marginTop = "0.25rem";
    desc.textContent = "Give your friends a reward and claim your own when they make a purchase.";
    li.appendChild(desc);

    // Link + copy
    var linkRow = document.createElement("div");
    linkRow.className = "rewards-page__code-row";
    linkRow.style.marginTop = "0.75rem";
    var linkCode = document.createElement("span");
    linkCode.className = "rewards-page__code";
    linkCode.textContent = referralUrl;
    linkCode.style.fontSize = "1rem";
    linkCode.style.wordBreak = "break-all";
    linkRow.appendChild(linkCode);
    var copyBtn = document.createElement("button");
    copyBtn.type = "button";
    copyBtn.className = "rewards-page__copy";
    copyBtn.innerHTML = ICON_COPY + " Copy";
    copyBtn.addEventListener("click", function () { copyToClipboard(referralUrl, copyBtn); });
    linkRow.appendChild(copyBtn);
    li.appendChild(linkRow);

    // Share row: Email (toggle), Facebook, X
    var shareRow = document.createElement("div");
    shareRow.className = "rewards-page__share-row";
    var encodedUrl = encodeURIComponent(referralUrl);
    var shareText = encodeURIComponent("Check out Summit Metals! Use my referral link:");

    var emailToggle = document.createElement("button");
    emailToggle.type = "button";
    emailToggle.className = "rewards-page__share-btn";
    emailToggle.textContent = "Email";
    shareRow.appendChild(emailToggle);

    var fbLink = document.createElement("a");
    fbLink.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodedUrl;
    fbLink.target = "_blank"; fbLink.rel = "noopener noreferrer";
    fbLink.className = "rewards-page__share-btn"; fbLink.textContent = "Facebook";
    shareRow.appendChild(fbLink);

    var xLink = document.createElement("a");
    xLink.href = "https://x.com/intent/tweet?text=" + shareText + "%20" + encodedUrl;
    xLink.target = "_blank"; xLink.rel = "noopener noreferrer";
    xLink.className = "rewards-page__share-btn"; xLink.textContent = "X";
    shareRow.appendChild(xLink);
    li.appendChild(shareRow);

    // Collapsible email form
    var emailForm = document.createElement("div");
    emailForm.className = "rewards-page__referral-form";
    emailForm.hidden = true;

    var toLabel = document.createElement("label");
    toLabel.className = "rewards-page__referral-label"; toLabel.textContent = "To";
    emailForm.appendChild(toLabel);
    var toInput = document.createElement("input");
    toInput.type = "email"; toInput.className = "rewards-page__referral-input";
    toInput.placeholder = "friend@example.com";
    emailForm.appendChild(toInput);

    var msgLabel = document.createElement("label");
    msgLabel.className = "rewards-page__referral-label"; msgLabel.textContent = "Message (optional)";
    emailForm.appendChild(msgLabel);
    var msgInput = document.createElement("textarea");
    msgInput.className = "rewards-page__referral-textarea";
    msgInput.placeholder = "Check out Summit Metals! I think you'll love it.";
    msgInput.rows = 3;
    emailForm.appendChild(msgInput);

    var sendFeedback = document.createElement("p");
    sendFeedback.className = "rewards-page__referral-feedback margin0";
    sendFeedback.hidden = true;
    emailForm.appendChild(sendFeedback);

    var sendBtn = document.createElement("button");
    sendBtn.type = "button";
    sendBtn.className = "rewards-page__earn-action";
    sendBtn.style.marginTop = "0.5rem";
    sendBtn.textContent = "Send email";
    sendBtn.addEventListener("click", function () {
      var email = toInput.value.trim();
      if (!email || !email.includes("@")) {
        sendFeedback.textContent = "Please enter a valid email address.";
        sendFeedback.style.color = "#f87171"; sendFeedback.hidden = false;
        return;
      }
      sendBtn.disabled = true; sendBtn.textContent = "Sending\u2026"; sendFeedback.hidden = true;
      var subject = encodeURIComponent("You've been invited to Summit Metals!");
      var body = encodeURIComponent((msgInput.value.trim() || "Check out Summit Metals! I think you'll love it.") + "\n\n" + referralUrl);
      window.open("mailto:" + encodeURIComponent(email) + "?subject=" + subject + "&body=" + body, "_self");
      sendBtn.textContent = "Sent!";
      sendFeedback.textContent = "Your email client should open with the referral link.";
      sendFeedback.style.color = "#4ade80"; sendFeedback.hidden = false;
      setTimeout(function () { sendBtn.textContent = "Send email"; sendBtn.disabled = false; }, 3000);
    });
    emailForm.appendChild(sendBtn);
    li.appendChild(emailForm);

    emailToggle.addEventListener("click", function () {
      emailForm.hidden = !emailForm.hidden;
      emailToggle.classList.toggle("rewards-page__share-btn--active", !emailForm.hidden);
      if (!emailForm.hidden) toInput.focus();
    });

    ul.appendChild(li);
    container.appendChild(ul);
  }

  /* ── VIP inline (inside hero section) ── */

  function renderVipInline(container, vs, tiers, walletBalance) {
    if (!container) return;
    container.innerHTML = "";

    var currentTierName = vs?.vipTier?.name || vs?.tier?.name || vs?.vip_tier?.name || null;
    var earnedPoints = vs?.progressValue ?? vs?.progress_value ?? null;
    if (earnedPoints == null && walletBalance != null) earnedPoints = walletBalance;

    var sortedTiers = (tiers || []).slice().sort(function (a, b) {
      return (a?.milestone ?? 0) - (b?.milestone ?? 0);
    });

    var currentIdx = -1;
    sortedTiers.forEach(function (t, i) { if (t?.name === currentTierName) currentIdx = i; });

    var nextTierFromSdk = vs?.nextVipTier ?? vs?.next_vip_tier ?? null;
    var deltaToNext = vs?.deltaToNextVipTier ?? vs?.delta_to_next_vip_tier ?? null;
    var nextTier = nextTierFromSdk || (currentIdx >= 0 && currentIdx < sortedTiers.length - 1 ? sortedTiers[currentIdx + 1] : null);
    var nextThreshold = null;
    if (nextTier) {
      for (var i = 0; i < sortedTiers.length; i++) {
        if (sortedTiers[i].id === nextTier.id || sortedTiers[i].name === nextTier.name) {
          nextThreshold = sortedTiers[i]?.milestone ?? null;
          break;
        }
      }
    }

    // Tier badge with icon
    if (currentTierName) {
      var badge = document.createElement("div");
      badge.className = "rewards-hero__vip-badge";
      badge.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 20.49 12 17.77 5.82 20.49 7 14.14 2 9.27 8.91 8.26 12 2"/></svg> ' + currentTierName + " Member";
      container.appendChild(badge);
    }

    // Progress bar
    if (earnedPoints != null && nextThreshold != null && nextThreshold > 0) {
      var pct = Math.min(Math.round((earnedPoints / nextThreshold) * 100), 100);
      var displayRemaining = deltaToNext != null ? deltaToNext : Math.max(nextThreshold - earnedPoints, 0);

      var progressWrap = document.createElement("div");
      progressWrap.className = "rewards-hero__vip-progress";

      var track = document.createElement("div");
      track.className = "rewards-vip-progress__track";
      var fill = document.createElement("div");
      fill.className = "rewards-vip-progress__fill";
      fill.style.width = pct + "%";
      track.appendChild(fill);
      progressWrap.appendChild(track);

      var label = document.createElement("p");
      label.className = "rewards-hero__vip-label margin0";
      label.textContent = displayRemaining > 0
        ? displayRemaining.toLocaleString() + " pts to " + (nextTier.name || "next tier")
        : "Top tier reached!";
      progressWrap.appendChild(label);

      container.appendChild(progressWrap);
    }
  }

  /* ── Activity / points history ── */

  function renderActivity(container, transactions) {
    if (!container) return 0;
    container.innerHTML = "";
    if (!transactions?.length) {
      var empty = document.createElement("p");
      empty.className = "rewards-page__meta";
      empty.style.cssText = "text-align:center;padding:2rem 1rem;";
      empty.textContent = "No reward activity yet. Start earning and redeeming points to see your history here!";
      container.appendChild(empty);
      return 0;
    }

    var ul = document.createElement("ul");
    ul.className = "rewards-page__list rewards-page__list--activity";

    transactions.forEach(function (tx) {
      var li = document.createElement("li");
      li.className = "rewards-page__item rewards-page__item--activity";

      var header = document.createElement("div");
      header.className = "rewards-page__activity-header";

      var titleEl = document.createElement("span");
      titleEl.className = "rewards-page__activity-title";
      titleEl.textContent = tx?.description || tx?.source || tx?.type || "Points activity";
      header.appendChild(titleEl);

      var pointsVal = tx?.points_change ?? tx?.pointsChange ?? tx?.points ?? null;
      if (pointsVal != null) {
        var pointsEl = document.createElement("span");
        pointsEl.className = "rewards-page__activity-points";
        if (pointsVal > 0) {
          pointsEl.classList.add("rewards-page__activity-points--positive");
          pointsEl.textContent = "+" + pointsVal.toLocaleString();
        } else {
          pointsEl.classList.add("rewards-page__activity-points--negative");
          pointsEl.textContent = pointsVal.toLocaleString();
        }
        header.appendChild(pointsEl);
      }

      li.appendChild(header);

      var metaRow = document.createElement("div");
      metaRow.className = "rewards-page__activity-meta";

      var dateVal = tx?.created_at ?? tx?.createdAt ?? tx?.date ?? null;
      if (dateVal) {
        var dateEl = document.createElement("span");
        dateEl.className = "rewards-page__activity-date";
        try { dateEl.textContent = new Date(dateVal).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
        catch (_) { dateEl.textContent = String(dateVal); }
        metaRow.appendChild(dateEl);
      }

      var st = tx?.status || "";
      if (st) {
        var badge = document.createElement("span");
        badge.className = "rewards-page__status " + statusClass(st);
        badge.textContent = st;
        metaRow.appendChild(badge);
      }

      li.appendChild(metaRow);
      ul.appendChild(li);
    });

    container.appendChild(ul);
    return transactions.length;
  }

  /* ── Main ── */

  async function main() {
    var root = qs("rewards-page-root");
    if (!root) return;

    var states = { loggedOut: qs("rewards-state-logged-out"), loading: qs("rewards-state-loading"), main: qs("rewards-state-main"), empty: qs("rewards-state-empty"), error: qs("rewards-state-error") };
    var summaryEl = qs("rewards-summary");
    var balanceEl = qs("rewards-balance");
    var listEl = qs("rewards-list-container");
    var earnListEl = qs("rewards-earn-list-container");
    var referralEl = qs("rewards-referral-container");
    var myRewardsEl = qs("rewards-my-rewards-container");
    var activityEl = qs("rewards-activity-container");
    var vipSectionEl = qs("rewards-vip-section");
    var vipContainerEl = qs("rewards-vip-container");
    var errEl = qs("rewards-error-message");
    var redeemEl = qs("rewards-redeem-result");
    var signInBtn = qs("rewards-open-auth");
    var bridge = window.SummitSmileBridge;
    var hasRenderedGoodData = false;
    var isLoadingRewards = false;
    var tabCtrl = TabController();
    var lastSmile = null;
    var lastProducts = null;
    var redeemCallbacks = null;

    function hideAll() { showEl(states.loggedOut, false); showEl(states.loading, false); showEl(states.main, false); showEl(states.empty, false); showEl(states.error, false); }
    function showError(msg) { if (errEl) errEl.textContent = msg || "Something went wrong."; hideAll(); showEl(states.error, true); }

    function updateBalance(Smile, wallet) {
      var balance = pickWalletBalance(wallet);
      if (balanceEl) balanceEl.innerHTML = formatBalNum(Smile, balance) + ' <span class="rewards-page__balance-label">Points</span>';
      return balance;
    }

    function refreshMyRewards(fulfillments) {
      var cards = (fulfillments || []).filter(function (item) {
        var s = pickRewardStatus(item);
        return s === "active" || s === "available";
      }).map(function (item) {
        var c = pickRewardCode(item);
        return { title: pickRewardTitle(item), code: c || null, meta: !c ? "Reward redeemed" : null, status: pickRewardStatus(item), expiresAt: item?.expires_at ?? item?.expiresAt ?? item?.expiry_date ?? item?.expiryDate ?? null };
      });
      var count = renderMyRewardCards(myRewardsEl, cards);
      tabCtrl.setAvailable("history", true);
      return count;
    }

    /* Shared post-redeem: show success message, then re-render everything with fresh balance */
    async function postRedeemRefresh(Smile, _purchase, feedbackEl) {
      // Fetch fresh wallet + fulfillments + products
      var newBalance = null;
      try {
        var fw = null;
        if (typeof Smile.customerPointsWallet?.get === "function") fw = await Smile.customerPointsWallet.get();
        if (fw) newBalance = updateBalance(Smile, fw);

        var ff = [];
        if (typeof Smile.rewardFulfillments?.get === "function") ff = await Smile.rewardFulfillments.get();
        if (ff?.length) { refreshMyRewards(ff); tabCtrl.show(); }

        // Re-fetch products too (some may become unavailable after redeem)
        var freshProducts = [];
        if (typeof Smile.pointsProducts?.get === "function") freshProducts = await Smile.pointsProducts.get();
        if (freshProducts?.length) lastProducts = freshProducts;
      } catch (_) { console.warn(LOG + " post-redeem refresh failed (non-fatal)", _); }

      // Re-render entire redeem list with fresh balance so sliders/buttons update
      if (lastProducts && redeemCallbacks && newBalance != null) {
        renderList(listEl, lastProducts, Smile, newBalance, redeemCallbacks.fixed, redeemCallbacks.variable);
      }

      // Show success feedback in the card
      if (feedbackEl) {
        feedbackEl.className = "rewards-page__card-feedback rewards-page__card-feedback--success";
        feedbackEl.hidden = false;
        feedbackEl.innerHTML = "";
        var successMsg = document.createElement("p");
        successMsg.className = "rewards-page__feedback-text margin0";
        successMsg.textContent = "Your code has been redeemed successfully!";
        feedbackEl.appendChild(successMsg);
        var hintMsg = document.createElement("p");
        hintMsg.className = "margin0";
        hintMsg.style.cssText = "font-size:1.1rem;color:var(--rewards-text);margin-top:0.35rem;";
        hintMsg.textContent = 'You can find the code under the "My Rewards" tab. You can also apply reward codes directly from the rewards widget during checkout.';
        feedbackEl.appendChild(hintMsg);
      }

      // Also update the top notice bar
      if (redeemEl) {
        redeemEl.textContent = "Reward redeemed! Check the \"My Rewards\" tab for your code.";
      }

      // Auto-switch to My Rewards tab after a short delay
      setTimeout(function () { tabCtrl.activate("history"); }, 3000);
    }

    /* Load guest-visible data (earning rules + products) without auth */
    async function loadGuestTeaser() {
      // Signed-out visitors only get Way to Redeem + Way to Earn (hide referral / my rewards / activity)
      tabCtrl.setAvailable("referral", false);
      tabCtrl.setAvailable("history", false);
      tabCtrl.setAvailable("activity", false);

      try {
        var Smile = await bridge.initSmilePublic();
        if (!Smile) return;

        if (isAuthenticated()) return;

        var earningRules = [];
        try { if (Smile.earningRules?.get) earningRules = await Smile.earningRules.get(); } catch (_e) { /* non-fatal */ }

        if (isAuthenticated()) return;

        var products = [];
        try { if (Smile.pointsProducts?.get) products = await Smile.pointsProducts.get(); } catch (_e) { /* non-fatal */ }

        if (isAuthenticated()) return;

        var earnCount = renderEarnCards(earnListEl, earningRules);
        tabCtrl.setAvailable("earn", earnCount > 0);

        var redeemCount = renderGuestList(listEl, products);
        tabCtrl.setAvailable("redeem", redeemCount > 0);

        if (earnCount > 0 || redeemCount > 0) {
          showEl(states.main, true);
          tabCtrl.show();
        }
      } catch (_e) {
        console.warn(LOG + " guest teaser failed (non-fatal)", _e);
      }
    }

    async function loadRewards() {
      if (isLoadingRewards) return;
      if (!isAuthenticated()) {
        hideAll();
        showEl(states.loggedOut, true);
        loadGuestTeaser();
        return;
      }
      isLoadingRewards = true;

      if (!hasRenderedGoodData) { hideAll(); showEl(states.loading, true); }
      if (redeemEl) redeemEl.textContent = "";

      try {
        var data = await bridge.withSmileRetry(async function () {
          var sync = await bridge.ensureFreshSmileLogin({ forceRefresh: false });
          if (!sync?.publishableKey || !sync?.customerToken) throw Object.assign(new Error("Missing Smile session"), { code: "NO_SESSION" });

          var Smile = await bridge.ensureSmileJsLoaded();

          var wallet = null;
          try { if (typeof Smile.customerPointsWallet?.preloaded === "function") wallet = Smile.customerPointsWallet.preloaded(); if (wallet == null && Smile.customerPointsWallet?.get) wallet = await Smile.customerPointsWallet.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          var products = [];
          try { if (typeof Smile.pointsProducts?.preloaded === "function") products = Smile.pointsProducts.preloaded() || []; if (!products?.length && Smile.pointsProducts?.get) products = await Smile.pointsProducts.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          var earningRules = [];
          try { if (typeof Smile.earningRules?.preloaded === "function") earningRules = Smile.earningRules.preloaded() || []; if (!earningRules?.length && Smile.earningRules?.get) earningRules = await Smile.earningRules.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          var rewardFulfillments = [];
          try { if (typeof Smile.rewardFulfillments?.preloaded === "function") rewardFulfillments = Smile.rewardFulfillments.preloaded() || []; if (!rewardFulfillments?.length && Smile.rewardFulfillments?.get) rewardFulfillments = await Smile.rewardFulfillments.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          var vipStatus = null;
          try { if (typeof Smile.customerVipStatus?.preloaded === "function") vipStatus = Smile.customerVipStatus.preloaded(); if (!vipStatus && Smile.customerVipStatus?.get) vipStatus = await Smile.customerVipStatus.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          var vipTiers = [];
          try { if (typeof Smile.vipTiers?.preloaded === "function") vipTiers = Smile.vipTiers.preloaded() || []; if (!vipTiers?.length && Smile.vipTiers?.get) vipTiers = await Smile.vipTiers.get(); } catch (e) { if (bridge.isSmileAuthError(e)) throw e; }

          return { Smile: Smile, wallet: wallet, products: products, earningRules: earningRules, rewardFulfillments: rewardFulfillments, vipStatus: vipStatus, vipTiers: vipTiers };
        });

        var Smile = data.Smile;
        var walletBalance = updateBalance(Smile, data.wallet);

        hideAll();
        showEl(states.main, true);
        showEl(summaryEl, true);

        // ── Redeem tab ──
        lastSmile = Smile;
        lastProducts = data.products;

        // Shared error handler — refresh balance after any redeem error
        async function handleRedeemError(e, btn, feedbackEl, orig) {
          feedbackEl.className = "rewards-page__card-feedback rewards-page__card-feedback--error"; feedbackEl.hidden = false;
          feedbackEl.innerHTML = "";
          var em = document.createElement("p"); em.className = "rewards-page__feedback-text margin0"; em.textContent = parseRedeemError(e);
          feedbackEl.appendChild(em); btn.textContent = orig; btn.disabled = false;
          // Auto-hide error after 5 seconds
          setTimeout(function () { feedbackEl.hidden = true; feedbackEl.innerHTML = ""; }, 5000);
          // Refresh balance + products + fulfillments after error to sync stale state
          try {
            var fw = await Smile.customerPointsWallet.get();
            var newBal = updateBalance(Smile, fw);
            var fp = await Smile.pointsProducts.get();
            if (fp?.length) lastProducts = fp;
            if (lastProducts && redeemCallbacks && newBal != null) {
              renderList(listEl, lastProducts, Smile, newBal, redeemCallbacks.fixed, redeemCallbacks.variable);
            }
            var ff = [];
            try { ff = await Smile.rewardFulfillments.get(); } catch (_) { /* ignore */ }
            refreshMyRewards(ff);
            var actItems = (ff || []).map(function (item) {
              var c = pickRewardCode(item);
              var pts = item?.points_spent ?? item?.pointsSpent ?? pickPointsCost(item) ?? null;
              return { description: pickRewardTitle(item) + (c ? " — " + c : ""), points_change: pts != null ? -pts : null, created_at: item?.created_at ?? item?.createdAt ?? null, status: pickRewardStatus(item) };
            });
            renderActivity(activityEl, actItems);
            tabCtrl.show();
          } catch (_) { /* non-fatal */ }
        }

        // Fixed redeem callback
        async function onRedeemFixed(pp, btn, feedbackEl) {
          btn.disabled = true; var orig = btn.textContent; btn.textContent = "Redeeming\u2026";
          feedbackEl.hidden = true; feedbackEl.innerHTML = ""; feedbackEl.className = "rewards-page__card-feedback";
          try {
            var purchase = await bridge.withSmileRetry(async function () { return await Smile.pointsProducts.purchase(pp.id); });
            await postRedeemRefresh(Smile, purchase, feedbackEl);
          } catch (e) {
            await handleRedeemError(e, btn, feedbackEl, orig);
          }
        }

        // Variable redeem callback
        async function onRedeemVariable(pp, btn, feedbackEl, pointsToSpend) {
          btn.disabled = true; var orig = btn.textContent; btn.textContent = "Redeeming\u2026";
          feedbackEl.hidden = true; feedbackEl.innerHTML = ""; feedbackEl.className = "rewards-page__card-feedback";
          try {
            var purchase = await bridge.withSmileRetry(async function () {
              return await Smile.pointsProducts.purchase(pp.id, { pointsToSpend: pointsToSpend });
            });
            await postRedeemRefresh(Smile, purchase, feedbackEl);
          } catch (e) {
            await handleRedeemError(e, btn, feedbackEl, orig);
          }
        }

        redeemCallbacks = { fixed: onRedeemFixed, variable: onRedeemVariable };

        var redeemCount = renderList(listEl, data.products, Smile, walletBalance, onRedeemFixed, onRedeemVariable);
        tabCtrl.setAvailable("redeem", redeemCount > 0);

        // ── Earn tab (with social buttons + birthday input) ──
        var earnCount = renderEarnCards(earnListEl, data.earningRules);
        tabCtrl.setAvailable("earn", earnCount > 0);

        // ── Referral tab ──
        var hasReferral = renderReferral(referralEl, Smile);
        tabCtrl.setAvailable("referral", hasReferral);

        // ── My rewards tab (active codes only) ──
        var myRewardsCount = refreshMyRewards(data.rewardFulfillments);

        // ── Activity tab (all fulfillments as history) ──
        var activityItems = (data.rewardFulfillments || []).map(function (item) {
          var code = pickRewardCode(item);
          var pts = item?.points_spent ?? item?.pointsSpent ?? pickPointsCost(item) ?? null;
          return {
            description: pickRewardTitle(item) + (code ? " — " + code : ""),
            points_change: pts != null ? -pts : null,
            created_at: item?.created_at ?? item?.createdAt ?? item?.redeemed_at ?? item?.redeemedAt ?? null,
            status: pickRewardStatus(item),
          };
        });
        var activityCount = renderActivity(activityEl, activityItems);
        tabCtrl.setAvailable("activity", true);

        // ── Show tabs ──
        tabCtrl.show();

        // ── VIP (inline in hero) ──
        var vs = data.vipStatus;
        var tiers = data.vipTiers || [];
        var heroVipEl = qs("rewards-hero-vip");
        var hasVip = !!(vs?.vipTier?.name || vs?.tier?.name || vs?.vip_tier?.name);
        if (hasVip && heroVipEl) {
          renderVipInline(heroVipEl, vs, tiers, walletBalance);
          showEl(heroVipEl, true);
        }
        // Hide the old separate VIP section
        showEl(vipSectionEl, false);

        showEl(states.empty, redeemCount === 0 && earnCount === 0);
        hasRenderedGoodData = true;
      } catch (e) {
        if (hasRenderedGoodData) { console.warn(LOG + " background refresh failed (non-fatal, keeping last data)", e); }
        else { showError("Rewards could not be loaded. Try again in a moment."); }
      } finally {
        isLoadingRewards = false;
      }
    }

    if (signInBtn) signInBtn.addEventListener("click", function () { openAuthModal(); });
    var sessionChangeTimer = null;
    window.addEventListener("supabase:session-change", function () {
      clearTimeout(sessionChangeTimer);
      sessionChangeTimer = setTimeout(loadRewards, 500);
    });

    // Birthday save — uses identity create_or_update endpoint with date_of_birth
    window.addEventListener("rewards:save-birthday", async function (e) {
      var date = e?.detail?.date;
      if (!date) return;
      var backendBaseUrl = window.SUMMIT_CHECKOUT_CONFIG?.backendBaseUrl;
      var accessToken = window.supabaseSession?.session?.access_token;
      var shop = window.Shopify?.shop || location.hostname;
      var btn = document.querySelector("#rewards-birthday-day + button");
      if (!backendBaseUrl || !accessToken) {
        if (btn) { btn.textContent = "Sign in first"; btn.disabled = false; }
        return;
      }
      try {
        var resp = await fetch(backendBaseUrl + "/api/smile/birthday", {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: "Bearer " + accessToken },
          body: JSON.stringify({ shop: shop, date_of_birth: date }),
          credentials: "include",
        });
        var result = await resp.json().catch(function () { return null; });
        if (resp.ok && result?.success) {
          if (btn) { btn.textContent = result?.awarded ? "Points awarded! \uD83C\uDF82" : "Saved!"; }
          // If points were awarded right now, clear the cached Smile session so
          // loadRewards() forces a full re-login and fetches the updated balance.
          // Give Smile's API ~1.5s to propagate the transaction before re-fetching.
          var delay = result?.awarded ? 1500 : 800;
          setTimeout(function () {
            if (result?.awarded && window.SummitSmileBridge?.clearSmileState) {
              window.SummitSmileBridge.clearSmileState();
            }
            loadRewards();
          }, delay);
        } else {
          throw new Error(result?.message || "Failed");
        }
      } catch (err) {
        console.warn(LOG + " birthday save failed", err);
        if (btn) { btn.textContent = "Failed"; btn.disabled = false; }
      }
    });

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", loadRewards);
    else loadRewards();
  }

  main();
})();
